<template >
	<BasicLayout v-loading="loading">       
		<div v-bind:class="backgroundColor" class="checkupTop">      
			<div class="checkupTitleTopDae">
				<span class="checkupTopText">
					{{ victim.lastname }} {{ victim.firstname }} 
					
					<span class="hidden-xs-only"> &nbsp; - &nbsp; {{all.fireunit}} , {{ all.vehicle }}</span>
					 

					
				</span>
			</div>    
		</div>

	  	<div class="y-style">
			<CheckupTabLite v-bind="{column:info, parameters:parameters}" />

			<br>
			<CheckupTab v-bind="{column:administration, parameters:parameters}"/>
			<br>
			<CheckupTab v-bind="{column:circ, parameters:parameters}"/>
			<br>
			<CheckupTab v-bind="{column:checkup, parameters:parameters2}"/>
	  	</div>
	  	<br>
		<div class="secondPos">
			<el-button size="large" icon="fas fa-times" class="btn-select btn-select-dae" v-on:click="getCancel()" title="Retour à la liste" >&nbsp; Retour<span class="hidden-xs-only"> à la Liste</span></el-button>
			<el-button size="large" icon="fas fa-check" class="btn-select btn-select-dae colorA" v-on:click="getValid()" title="Clore (Effacer de la Liste)" >&nbsp; Clore<span class="hidden-xs-only"> (Effacer de la Liste)</span> </el-button>
		</div>
	</BasicLayout>
</template>

<script>
import BasicLayout from "@/layouts/basic.layout.vue"
import CheckupTab from '@/components/checkup.detail.tab.component.vue';
import CheckupTabLite from '@/components/checkup.detail.tab.lite.component.vue';
import DaeService from '@/services/dae.service'
import VictimService from '@/services/victim.service'
import '@/style/theme/index.css'

export default {    
	computed: {
		backgroundColor() {
			if (this.victim.checkupColor == null){
				return null;
			} else{
				return this.victim.checkupColor.toLowerCase() + '-background';
			}
		}
	},
	components: {
		BasicLayout,
		CheckupTab,
		CheckupTabLite,
		DaeService,
		VictimService
	}	,
	data() {
		return {
			html:"",
			administration:{},
			circ:{},
			info:{},
			checkup:{},
			victim:{},
			all:{},
			loading: true,
			parameters:{
			  withTitle: false,
			  classColor: "colorAdmin",
			  borderLeft : "",
			  borderRight : "" 
			},
			parameters2:{
			  withTitle: false,
			  classColor: "colorS",
			  borderLeft : "",
			  borderRight : "" 
			}
		}
	},
	methods: {
		getData() {
			// Appel de l'api
			DaeService.getDae(this.$route.params.victimId,this.$route.params.order).then((result) => {

				// On affecte le résultat à "all"
				this.all = result;
				this.victim = result.victim;


				// ===========================================================
				// Info
				// ===========================================================
				
		
					var town 			=  result.victim.town;
					var adresse1		=  result.victim.address1;
					var adresse2		=  result.victim.address2;
					var operationNumber		=  result.victim.operationNumber;					
					var leaderNumber	=  result.victim.leaderNumber ;

					var col1 = { title:'Adresse : ', adresse1, adresse2, town };
					var col2 = { title: 'Intervention : ', operationNumber };
					var col3 = { title:'Matricule CA : ', leaderNumber };
				
				this.info = {leftTitle:'Info',col01: col1 ,col02: col2,col03: col3}

				// ===========================================================
				// Administration
				// ===========================================================
				this.administration = {leftTitle: result.detail[1].libelle, col01 : result.detail[1].child1, col02 : result.detail[1].child2, col03 : result.detail[1].child3};
				this.circ = {leftTitle: result.detail[2].libelle, col01 : result.detail[2].child1, col02 : null, col03 : null};

				// Dans le bloc "Circonstances", on ne veut afficher que "enfant" et "lieu"
				this.circ.col01.forEach((item, index, object) => {
					if (item.id !== 'lieu' && item.id !== 'enfant') {
						object.splice(index, 1);
					}
				})

				// ===========================================================
				// DAE
				// ===========================================================
				// initialisation des colonnes (premier affichage)
				this.checkup = {leftTitle: result.detail[0].libelle, col01 : result.detail[0].child1, col02 : result.detail[0].child2, col03 : result.detail[0].child3};                

				// ajout du sexe pour les lesions
				this.checkup.gender = result.victim.gender;
				this.loading = false;
	  })
	  
	},
	getValid() {
			// Appel de l'api
			VictimService.updateDae(this.$route.params.victimId);
			this.$router.push({ name: 'Daes' });
	  },
	getCancel() {
			this.$router.push({ name: 'Daes' });
	  }
	},
	mounted: function() {
		this.getData();	
	}

};
</script>

<style>


	.right{
	  text-align: right;
	}

	.y-style{
		overflow-y: scroll;
		height: calc(100vh - 250px);
	}

	.width-td-md{
		width: 33.33%
	}

	td{
		vertical-align:top;
	}

	.border-r{
		border-right-width: 6px;
		border-right-style: solid;
		border-color: white;
	}

	.border-l{
		border-left-width: 3px;
		border-left-style: solid;
		border-color: white;
	}

	.checkupTitleTopDae{
		width: 100%;
		display: inline-block;
		padding: 3px 0px 3px 0px !important;
	}



	.checkupTop{ 
		width: 100%;
		border-radius: 10px 10px 0px 0px !important;
	}

	.printButton{
		margin: 0px 4px 0px 0px !important;
		border-radius: 0px 10px 4px 0px !important;
	}

	.copyButton{
		border-radius: 4px 0px 0px 4px !important;
	}

	.selectOrder{
		width: 85px;
	}
	.divSelectOrder{
		display: inline-block;
		vertical-align: middle;
	}

	.checkupBottom{ 
		font-size: 13px;
		border-radius: 0px 0px 10px 10px !important;
	}

	.checkupTopText{ 
		margin: 20px;
		font-size: 14px;
		}
	
	.rouge-checkupGravity{
		background-image: linear-gradient(to right, rgb(255, 0, 0),rgba(255, 0, 0,0.8));
		color:white;
	}


	.vert-checkupGravity{
		background-image: linear-gradient(to right, rgb(100, 210, 0),rgba(100, 210, 0,0.8));
	}

	.jaune-checkupGravity{
		background-image: linear-gradient(to right, rgb(235, 235, 20), rgba(235, 235, 20,0.8));
	}

	.vertjaune-checkupGravity{
		background-image: linear-gradient(to right, rgb(235, 235,0), rgba(100, 210, 0,0.9));
	}

	.blanc-checkupGravity{
		background-image: linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.8));
	}


/*   =============================================  
	 Texte au dessus des boutons  + boutons
	 =============================================
*/

  /*   taille,couleur,position titre */
  .titreFont {
	font-size: 22px;
	color: rgb(240, 159, 38);
	text-align: center;
  }

  /*   Position de Primaire */
  .primPos {
	text-align: start;
  }

  /*   Position de Secondaire */
  .secondPos {
	text-align: right;
  }

  /*   taille et couleur  prim et second */
  .primSecondFont {
	font-size: 16px;
	color: dimgray;
  }

	/*   taille bouton */
  .btn-select-dae {
	padding-left: 35px;
	padding-right: 35px;
  }

/*   =============================================  
	 Contenu + bandeau 
	 =============================================
*/

  .title2 {
	text-align: center;
	font-size: 16px;
	padding: 1px;
  }

  /*   Contenant */
  .divTable {
	display: table;
	width: 100%;
	table-layout: fixed;
	vertical-align: middle;
  }

  /*   contenu principal */
  .table {
	width: 100%;
	height: 100%;
	border-spacing: 0px;
  }

  /*   Bandeau du haut mode smartphone  */
  .divCellTop {
	display: table-row;
	font-size: 16px;
	text-align: center;
  }

  /*   Bandeau de gauche (sauf mode smartphone) */
  .divCellLeft {
	display: table-cell;
	font-size: 18px;
	width: 28px;
	padding-left: 7px;
	vertical-align: top;
  }

  .divCell {
	display: table-cell;
	font-size: 13px;
  }


  .rotate {
	writing-mode: vertical-lr; 
	transform: rotate(180deg);
	margin-top: -13px;
	padding-bottom: 23px;
	margin-bottom: 10px;
  }

/*   =============================================  
	 Couleurs 
	 =============================================
*/

/*   Couleurs Administration */
/*   ----------------------------------------------- */
	.colorAdmin {
	color: #ffffff;
	background-color: #a7a7a7;
	
	}
	.colorAdmin-td {
	color: #000000;
	background-color: rgb(243, 243, 243);
	}

  /*   Couleurs A */
  /*   ----------------------------------------------- */
  .colorA {
	color: #ffffff;
	background-color: rgb(63, 174, 73);
  }

  .colorA-td {
	color: #000000;
	background-color: rgba(63, 174, 73,0.3);
  }

  .btn-select.focus.colorA {
	color: #000000;
	background-color: rgba(63, 174, 73,0.6);
  }

  .btn-select.colorA:hover {
	color: #000000;
	background-color: rgba(63, 174, 73,0.4);
  }

 
  /*   Couleurs SECONDAIRE */
  /*   ----------------------------------------------- */
  .colorS {
	color: #ffffff;
	background-color: rgb(13, 108, 193);
  }
  .colorS-td {
	color: #000000;
	background-color: rgba(13, 108, 193, 0.3);
  }

  .btn-select.focus.colorS {
	color: #000000;
	background-color: rgba(13, 108, 193, 0.6);
  }

  .btn-select.colorS:hover {
	color: #000000;
	background-color: rgba(13, 108, 193, 0.4);
  }



/*   =============================================  
	 Classe pour le mode smartphone
	 =============================================
*/
@media only screen and (max-width: 767px) {
 
	/*   Position des boutons */
	.primPos {
		text-align: center;
	}
 
	/*   Position des boutons */
	.secondPos {
		text-align: center;
	}

	.y-style{
		overflow-y: scroll;
		height: calc(100vh - 200px);
	}



}
</style>